import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error404 from "./common/Error404";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import Permission from "./pages/CustomRules";
import Profile from "./pages/Profile";
import Projects from "./pages/Projects";
import Employees from "./pages/Employees";
import Payment from "./pages/Payment";
import Deduction from "./pages/Deduction";
import PaymentLink from "./pages/PaymentLink";
import Financial from "./pages/Financial";
import Leads from "./pages/HRM/Leads";
import Certificate from "./pages/Certificate";
import Allowances from "./pages/Allowances";
import Notification from "./pages/Notification";
import Holiday from "./pages/Holiday";
import LoanManagement from "./pages/HRM/LoanManagement";
import Salaries from "./pages/HRM/Salaries";
import PayrollDetails from "./pages/HRM/Salaries/PayrollDetails";
import Organization from "./pages/HRM/Organization";
import AddOrganization from "./pages/HRM/Organization/AddOrganization";
import Employee from "./pages/HRM/Employee";
import EmployeeProfile from "./pages/HRM/EmployeeProfile";
import HRMDashboard from "./pages/Dashboards/HRMDashboard";
import EmployeeDashboard from "./pages/Dashboards/EmployeeDashboard";
import CRMAnalytics from "./pages/Dashboards/CRMAnalytics";
import Designations from "./pages/HRM/Designations";
import Branches from "./pages/Company/Branches";
import Departments from "./pages/Company/Departments";
import Assets from "./pages/Company/Assets";
import Company from "./pages/Company/Company";
import CompanyPolicy from "./pages/Company/CompanyPolicy";
import WorkShift from "./pages/Company/WorkShift";
import AddEmployee from "./pages/HRM/Employee/AddEmployee";
import JobType from "./pages/HRM/JobType";
import Admins from "./pages/AdminManagment/Admin";
import AddAdmin from "./pages/AdminManagment/Admin/AddAdmin";
import Roles from "./pages/AdminManagment/Roles";
import Attendance from "./pages/HRM/Attendance";
import AddPermission from "./pages/AdminManagment/Roles/AddRole";
import Requests from "./pages/HRM/Requests";

const Markup = () => {
	const allroutes = [
		// Dashboards
		{ url: "/", component: <HRMDashboard /> },
		{ url: "/hrm-dashboard", component: <HRMDashboard /> },
		{ url: "/employee-dashboard", component: <EmployeeDashboard /> },
		{ url: "/crm-analytics", component: <CRMAnalytics /> },

		// Admin Managment
		{ url: "/admins", component: <Admins /> },
		{ url: "add-admins", component: <AddAdmin /> },
		{ url: "edit-admin/:id/:name", component: <AddAdmin /> },
		{ url: "/roles", component: <Roles /> },
		{ url: "roles/add-role", component: <AddPermission /> },
		{ url: "roles/:id", component: <AddPermission /> },

		// Company
		{ url: "/company", component: <Company /> },
		{ url: "/company-policy", component: <CompanyPolicy /> },
		{ url: "/branches", component: <Branches /> },
		{ url: "/departments", component: <Departments /> },
		{ url: "/work-shift", component: <WorkShift /> },
		{ url: "/assets", component: <Assets /> },

		// Employee
		{ url: "/employee", component: <Employee /> },
		{ url: "/employee/add-employee", component: <AddEmployee /> },
		{ url: "/employee/edit-employee/:id", component: <AddEmployee /> },
		{ url: "/employee/:id", component: <EmployeeProfile /> },
		{ url: "/designations", component: <Designations /> },
		{ url: "/job-type", component: <JobType /> },
		{ url: "/attendance", component: <Attendance /> },
		{ url: "/requests", component: <Requests /> },

		// Rules
		// { url: "rules", component: <Permission /> },
		// { url: "rules/:id", component: <Permission /> },

		// Attendance
		// { url: "attendance", component: <Attendance /> },

		// Financial
		// { url: "financial", component: <Financial /> },

		// Payment Link
		// { url: "payment-link", component: <PaymentLink /> },

		// Holiday
		// { url: "holiday", component: <Holiday /> },

		// Projects
		// { url: "projects", component: <Projects /> },

		// Leads
		// { url: "leads", component: <Leads /> },

		// Deduction
		// { url: "deduction", component: <Deduction /> },

		// Payment
		// { url: "payment", component: <Payment /> },

		// Profile
		// { url: "profile", component: <Profile /> },

		// Allowances
		{ url: "allowances", component: <Allowances /> },

		// JobTitle
		// { url: "job-title", component: <JobTitle /> },

		// organization
		{ url: "organization", component: <Organization /> },
		{ url: "organization/add-organization", component: <AddOrganization /> },
		{ url: "organization/edit-organization", component: <AddOrganization /> },
		{ url: "organization/view-organization", component: <AddOrganization /> },

		// Loans
		{ url: "loans", component: <LoanManagement /> },
		{ url: "leads", component: <Leads /> },

		// Salaries
		{ url: "/salaries", component: <Salaries /> },
		{ url: "/salaries/payroll/:employeeId", component: <PayrollDetails /> },

		// Notification
		{ url: "notifications", component: <Notification /> },

		// Certificate
		// { url: "employee-letters", component: <Certificate /> },

		// Error
		{ url: "*", component: <Error404 /> },
	];

	return (
		<>
			<Routes>
				<Route path="page-error-404" element={<Error404 />} />
				<Route element={<MainLayout />}>
					{allroutes.map((data, i) => (
						<Route
							key={i}
							exact
							path={`${data.url}`}
							element={data.component}
						/>
					))}
				</Route>
			</Routes>
			<ScrollToTop />
		</>
	);
};

function MainLayout() {
	return (
		<div id="main-wrapper" className={`show `}>
			<Nav />
			<div
				className="content-body"
				style={{ minHeight: window.screen.height - 45 }}>
				<div className="mt-3">
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default Markup;
